import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { CollectionBooster } from '../collection-booster.model';

@JsonObject('CollectionsBoostersResultsResponse')
export class CollectionsBoostersResultsResponse extends ApiResultsResponse<CollectionBooster> {

  @JsonProperty('results', [CollectionBooster])
  override results: CollectionBooster[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
